<template>
    <div style="  height: 100%;">
        <text>注：本表所列项目无测量时，观测数据和测量结果可不填写，但结果判定应填写（“√”、“×”、“/”），对不适用项填“/”。</text>
        <el-form ref="form" :model="formData">
            <!-- 序号: 1 extra="项目编号: A2.2.2.1"  -->
            <el-descriptions title="序号: 1 项目编号: A2.2.2.1"
                      style="  ">
                <template #extra >
                </template>
            </el-descriptions>
            <div style="display:flex;flex-direction: row; ">
                <div style="font-weight:bold">&nbsp;&nbsp;</div>
                <div style="font-weight:bold">(1)&nbsp;&nbsp;检测内容与要求: <text
                        style="font-weight:100">测量在楼层板平面的梳齿与踏面相交线位置的照度是否至少为50lx</text></div>

            </div>
            <div style="display:flex;flex-direction: row; justify-content: space-around; margin-top: 10px">

                <div style="font-weight:bold">&nbsp;&nbsp;检测项目:<text style="font-weight:100">照度</text></div>

                <div style="font-weight:bold">&nbsp;&nbsp;单位: <text style="font-weight:100">lx</text></div>
                <div style="font-weight:bold">&nbsp;&nbsp;观测数据:
                    <el-input style="font-weight:100;width:200px" v-model="formData.data1" placeholder="请输入">
                    </el-input></div>
                <div style="font-weight:bold">&nbsp;&nbsp;测量结果:
                    <el-input style="font-weight:100;width:200px"   v-model="formData.result1" placeholder="请输入">
                    </el-input></div>
            </div>
            <div style="font-weight:bold; margin-top: 10px">&nbsp;&nbsp;结果判定:
                <el-radio-group v-model="formData.determine1">
                    <el-radio label="√"></el-radio>
                    <el-radio label="×"></el-radio>
                    <el-radio label="/"></el-radio>
                </el-radio-group>
            </div>

            <!-- 序号: 2 -->
            <el-descriptions title="序号: 2 项目编号: A2.2.2.2"
                             style="  ">
            </el-descriptions>
            <div style="display:flex;flex-direction: row; margin-top: 10px ">
                <div style="font-weight:bold">&nbsp;&nbsp;(1)</div>
                <div style="font-weight:bold">&nbsp;&nbsp;检测内容与要求: <text
                        style="font-weight:100">检查出入口区域是否充分畅通，其宽度至少等于扶手带外缘距离加上每边各80mm，纵深尺寸从扶手装置端部算起至少为2.50m；该区域的宽度不小于扶手带外缘之间距离的2倍加上每边各80mm时，其纵深尺寸允许减少至2.00m</text>
                </div>
            </div>
            <div  style="display:flex;flex-direction: row; justify-content: space-around;margin-top: 10px ">
                <div style="font-weight:bold">&nbsp;&nbsp;检测项目: <text style="font-weight:100">出入口区域宽度</text></div>
                <div style="font-weight:bold">&nbsp;&nbsp;单位: <text style="font-weight:100">mm</text></div>

                <div style="font-weight:bold; ">
                    观测数据:
                    <el-input style="font-weight:100;width:200px;" v-model="formData.data2" placeholder="请输入">
                </el-input></div>
                <div style="font-weight:bold">&nbsp;&nbsp;测量结果: <el-input style="font-weight:100;width:200px;"
                                                                          v-model="formData.result2" placeholder="请输入">
                </el-input></div>
            </div>
            <div  style="display:flex;flex-direction: row; justify-content: space-around;margin-top: 10px ">
                <div style="font-weight:bold">&nbsp;&nbsp;检测项目: <text style="font-weight:100">出入口区域纵深尺寸</text></div>
                <div style="font-weight:bold">&nbsp;&nbsp;单位: <text style="font-weight:100">m</text></div>
                <div style="font-weight:bold">&nbsp;&nbsp;观测数据: <el-input style="font-weight:100; width: 200px"
                                                                          v-model="formData.data3" placeholder="请输入">
                </el-input></div>
                <div style="font-weight:bold">&nbsp;&nbsp;测量结果: <el-input style="font-weight:100;  width: 200px"
                                                                          v-model="formData.result3" placeholder="请输入">
                </el-input></div>
            </div>
            <div style="font-weight:bold;margin-top: 10px ">&nbsp;&nbsp;结果判定:
                <el-radio-group v-model="formData.determine2">
                    <el-radio label="√"></el-radio>
                    <el-radio label="×"></el-radio>
                    <el-radio label="/"></el-radio>
                </el-radio-group>
            </div>
            <!-- 序号: 3 -->
            <el-descriptions title="序号: 3 项目编号: A2.2.2.3"
                             style="  ">
            </el-descriptions>
            <div style="display:flex;flex-direction: row; ">
                <div style="font-weight:bold">&nbsp;&nbsp;(1)</div>
                <div style="font-weight:bold">&nbsp;&nbsp;检测内容与要求: <text
                        style="font-weight:100">出入口防护装置至少高出扶手带100mm，位于扶手带外缘80mm～120mm处</text>
                </div>
            </div>
            <div  style="display:flex;flex-direction: row; justify-content: space-around;margin-top: 10px ">
                <div style="font-weight:bold">&nbsp;&nbsp;检测项目: <text style="font-weight:100">高出扶手带的距离</text></div>
                <div style="font-weight:bold">&nbsp;&nbsp;单位: <text style="font-weight:100">mm</text></div>
                <div style="font-weight:bold">&nbsp;&nbsp;观测数据: <el-input style="font-weight:100;width: 200px"
                                                                          v-model="formData.data4" placeholder="请输入">
                </el-input></div>
                <div style="font-weight:bold">&nbsp;&nbsp;测量结果: <el-input style="font-weight:100;width: 200px"
                                                                          v-model="formData.result4" placeholder="请输入">
                </el-input></div>

            </div>
            <div  style="display:flex;flex-direction: row; justify-content: space-around;margin-top: 10px ">
                <div style="font-weight:bold">&nbsp;&nbsp;检测项目: <text style="font-weight:100">与扶手带外缘距离</text></div>
                <div style="font-weight:bold">&nbsp;&nbsp;单位: <text style="font-weight:100">mm</text></div>
                <div style="font-weight:bold">&nbsp;&nbsp;观测数据: <el-input style="font-weight:100; width: 200px"
                                                                          v-model="formData.data5" placeholder="请输入">
                </el-input></div>
                <div style="font-weight:bold">&nbsp;&nbsp;测量结果: <el-input style="font-weight:100;width: 200px"
                                                                          v-model="formData.result5" placeholder="请输入">
                </el-input></div>
            </div>
            <div style="display:flex;flex-direction: row; ">
                <div style="font-weight:bold">&nbsp;&nbsp;(2)</div>
                <div style="font-weight:bold">&nbsp;&nbsp;检测内容与要求: <text
                        style="font-weight:100">出入口防护装置从楼层板起高度不小于1100mm</text>
                </div>
            </div>
            <div  style="display:flex;flex-direction: row; justify-content: space-around;margin-top: 10px ">
                <div style="font-weight:bold">&nbsp;&nbsp;检测项目: <text style="font-weight:100">从楼层板起的高度</text></div>
                <div style="font-weight:bold">&nbsp;&nbsp;单位: <text style="font-weight:100">mm</text></div>
                <div style="font-weight:bold">&nbsp;&nbsp;观测数据: <el-input style="font-weight:100;width: 200px"
                                                                          v-model="formData.data6" placeholder="请输入">
                </el-input></div>
                <div style="font-weight:bold">&nbsp;&nbsp;测量结果: <el-input style="font-weight:100;width: 200px"
                                                                          v-model="formData.result6" placeholder="请输入">
                </el-input></div>
            </div>
            <div style="font-weight:bold;margin-top: 10px ">&nbsp;&nbsp;结果判定:
                <el-radio-group v-model="formData.determine3">
                    <el-radio label="√"></el-radio>
                    <el-radio label="×"></el-radio>
                    <el-radio label="/"></el-radio>
                </el-radio-group>
            </div>
            <!-- 序号: 4 -->
            <el-descriptions title="序号: 4 项目编号: A2.2.2.4"
                             style="  ">
            </el-descriptions>
            <div style="display:flex;flex-direction: row; ">
                <div style="font-weight:bold">&nbsp;&nbsp;(1)</div>
                <div style="font-weight:bold">&nbsp;&nbsp;检测内容与要求: <text
                        style="font-weight:100">受检设备与楼板有交叉或者受检设备之间有交叉的，检查交叉处是否设有垂直固定、无锐利边缘的封闭防护挡板，其位于扶手带上方的防护高度不小于0.30m，并且延伸至扶手带下缘以下至少25mm。扶手带外缘与任何障碍物之间的距离不小于400mm的，可以不设置防护挡板</text>
                </div>
            </div>
            <div  style="display:flex;flex-direction: row; justify-content: space-around;margin-top: 10px ">
                <div style="font-weight:bold">&nbsp;&nbsp;检测项目: <text style="font-weight:100">防护挡板高度</text></div>
                <div style="font-weight:bold">&nbsp;&nbsp;单位: <text style="font-weight:100">m</text></div>
                <div style="font-weight:bold">&nbsp;&nbsp;观测数据: <el-input style="font-weight:100;width:200px"
                                                                          v-model="formData.data7" placeholder="请输入">
                </el-input></div>
                <div style="font-weight:bold">&nbsp;&nbsp;测量结果: <el-input style="font-weight:100;width:200px"
                                                                          v-model="formData.result7" placeholder="请输入">
                </el-input></div>
            </div>
            <div  style="display:flex;flex-direction: row; justify-content: space-around;margin-top: 10px ">
                <div style="font-weight:bold">&nbsp;&nbsp;检测项目: <text style="font-weight:100">扶手带下缘以下距离</text></div>
                <div style="font-weight:bold">&nbsp;&nbsp;单位: <text style="font-weight:100">mm</text></div>
                <div style="font-weight:bold">&nbsp;&nbsp;观测数据: <el-input style="font-weight:100;width:200px"
                                                                          v-model="formData.data8" placeholder="请输入">
                </el-input></div>
                <div style="font-weight:bold">&nbsp;&nbsp;测量结果: <el-input style="font-weight:100;width:200px"
                                                                          v-model="formData.result8" placeholder="请输入">
                </el-input></div>
            </div>
            <div style="font-weight:bold;margin-top: 10px">&nbsp;&nbsp;结果判定:
                <el-radio-group v-model="formData.determine4">
                    <el-radio label="√"></el-radio>
                    <el-radio label="×"></el-radio>
                    <el-radio label="/"></el-radio>
                </el-radio-group>
            </div>
            <!-- 序号: 5 -->
            <el-descriptions title="序号: 5 项目编号: A2.2.2.5"
                             style="  ">
            </el-descriptions>
            <div style="display:flex;flex-direction: row;">
                <div style="font-weight:bold">&nbsp;&nbsp;(1)</div>
                <div style="font-weight:bold">&nbsp;&nbsp;检测内容与要求: <text
                        style="font-weight:100">墙壁或者障碍物与扶手带外缘之间的水平距离不小于80mm，与扶手带下缘的垂直距离不小于25mm</text>
                </div>


            </div>
            <div  style="display:flex;flex-direction: row; justify-content: space-around;margin-top: 10px ">
                <div style="font-weight:bold">&nbsp;&nbsp;检测项目: <text style="font-weight:100">水平距离</text></div>
                <div style="font-weight:bold">&nbsp;&nbsp;单位: <text style="font-weight:100">mm</text></div>
                <div style="font-weight:bold">&nbsp;&nbsp;观测数据: <el-input style="font-weight:100;width: 200px"
                                                                          v-model="formData.data9" placeholder="请输入">
                </el-input></div>
                <div style="font-weight:bold">&nbsp;&nbsp;测量结果: <el-input style="font-weight:100;width: 200px"
                                                                          v-model="formData.result9" placeholder="请输入">
                </el-input></div>
            </div>
            <div  style="display:flex;flex-direction: row; justify-content: space-around;margin-top: 10px ">
                <div style="font-weight:bold">&nbsp;&nbsp;检测项目: <text style="font-weight:100">垂直距离</text></div>
                <div style="font-weight:bold">&nbsp;&nbsp;单位: <text style="font-weight:100">mm</text></div>
                <div style="font-weight:bold">&nbsp;&nbsp;观测数据: <el-input style="font-weight:100;width: 200px"
                                                                          v-model="formData.data10" placeholder="请输入">
                </el-input></div>
                <div style="font-weight:bold">&nbsp;&nbsp;测量结果: <el-input style="font-weight:100;width: 200px"
                                                                          v-model="formData.result10" placeholder="请输入">
                </el-input></div>
            </div>
            <div style="font-weight:bold;margin-top: 10px">&nbsp;&nbsp;结果判定:
                <el-radio-group v-model="formData.determine5">
                    <el-radio label="√"></el-radio>
                    <el-radio label="×"></el-radio>
                    <el-radio label="/"></el-radio>
                </el-radio-group>
            </div>
            <div style="display:flex;flex-direction: row;margin-top: 10px ">
                <div style="font-weight:bold">&nbsp;&nbsp;(2)</div>
                <div style="font-weight:bold">&nbsp;&nbsp;检测内容与要求: <text
                        style="font-weight:100">对于邻近布置的受检设备，其扶手带外缘之间的距离不小于160mm</text>
                </div>


            </div>
            <div  style="display:flex;flex-direction: row; justify-content: space-around;margin-top: 10px ">
                <div style="font-weight:bold">&nbsp;&nbsp;检测项目: <text style="font-weight:100">邻近扶手带外缘之间的距离</text>
                </div>
                <div style="font-weight:bold">&nbsp;&nbsp;单位: <text style="font-weight:100">mm</text></div>
                <div style="font-weight:bold ">&nbsp;&nbsp;观测数据: <el-input style="font-weight:100;width: 200px"
                                                                          v-model="formData.data11" placeholder="请输入">
                </el-input></div>
                <div style="font-weight:bold">&nbsp;&nbsp;测量结果: <el-input style="font-weight:100;width: 200px"
                                                                          v-model="formData.result11" placeholder="请输入">
                </el-input></div>
            </div>
            <div style="font-weight:bold; margin-top:10px">&nbsp;&nbsp;结果判定:
                <el-radio-group v-model="formData.determine6">
                    <el-radio label="√"></el-radio>
                    <el-radio label="×"></el-radio>
                    <el-radio label="/"></el-radio>
                </el-radio-group>
            </div>
            <!-- 序号: 6 -->
            <el-descriptions title="序号: 6 项目编号: A2.2.2.6"
                             style="  ">
            </el-descriptions>
            <div style="display:flex;flex-direction: row;">
                <div style="font-weight:bold">&nbsp;&nbsp;(2)</div>
                <div style="font-weight:bold">&nbsp;&nbsp;检测内容与要求: <text
                        style="font-weight:100">多台连续并且无中间出口的受检设备，在梯级、踏板或胶带到达梳齿与踏面相交线之前2.00m～3.00m处，设有乘客易于触及的附加紧急停止开关</text>
                </div>


            </div>
            <div  style="display:flex;flex-direction: row; justify-content: space-around;margin-top: 10px ">
                <div style="font-weight:bold">&nbsp;&nbsp;检测项目: <text style="font-weight:100">附加紧急停止开关与踏面相交线的距离</text>
                </div>
                <div style="font-weight:bold">&nbsp;&nbsp;单位: <text style="font-weight:100">m</text></div>
                <div style="font-weight:bold">&nbsp;&nbsp;观测数据: <el-input style="font-weight:100;width: 200px;"
                                                                          v-model="formData.data12" placeholder="请输入">
                </el-input></div>
                <div style="font-weight:bold">&nbsp;&nbsp;测量结果: <el-input style="font-weight:100;width: 200px;"
                                                                          v-model="formData.result12" placeholder="请输入">
                </el-input></div>
            </div>

            <div style="font-weight:bold;margin-top: 10px">&nbsp;&nbsp;结果判定:
                <el-radio-group v-model="formData.determine7">
                    <el-radio label="√"></el-radio>
                    <el-radio label="×"></el-radio>
                    <el-radio label="/"></el-radio>
                </el-radio-group>
            </div>
            <!-- 序号: 7 -->
            <el-descriptions title="序号: 7 项目编号: A2.2.2.8"
                             style="  ">
            </el-descriptions>
            <div style="display:flex;flex-direction: row;  ">
                <div style="font-weight:bold">&nbsp;&nbsp;(2)</div>
                <div style="font-weight:bold">&nbsp;&nbsp;检测内容与要求: <text
                        style="font-weight:100">梳齿板梳齿与踏面齿槽的啮合深度至少为4mm，梳齿槽根部与踏面的间隙不超过4mm</text>
                </div>
            </div>
            <div  style="display:flex;flex-direction: row; justify-content: space-around;margin-top: 10px ">
                <div style="font-weight:bold">&nbsp;&nbsp;检测项目: <text style="font-weight:100">啮合深度</text></div>
                <div style="font-weight:bold">&nbsp;&nbsp;单位: <text style="font-weight:100">mm</text></div>
                <div style="font-weight:bold">&nbsp;&nbsp;观测数据: <el-input style="font-weight:100;width:200px"
                                                                          v-model="formData.data13" placeholder="请输入">
                </el-input></div>
                <div style="font-weight:bold">&nbsp;&nbsp;测量结果: <el-input style="font-weight:100;width:200px"
                                                                          v-model="formData.result13" placeholder="请输入">
                </el-input></div>
            </div>
            <div  style="display:flex;flex-direction: row; justify-content: space-around;margin-top: 10px ">
                <div style="font-weight:bold">&nbsp;&nbsp;检测项目: <text style="font-weight:100">间隙</text></div>
                <div style="font-weight:bold">&nbsp;&nbsp;单位: <text style="font-weight:100">mm</text></div>
                <div style="font-weight:bold">&nbsp;&nbsp;观测数据: <el-input style="font-weight:100;width:200px"
                                                                          v-model="formData.data14" placeholder="请输入">
                </el-input></div>
                <div style="font-weight:bold">&nbsp;&nbsp;测量结果: <el-input style="font-weight:100;width:200px"
                                                                          v-model="formData.result14" placeholder="请输入">
                </el-input></div>
            </div>
            <div style="font-weight:bold;margin-top: 10px">&nbsp;&nbsp;结果判定:
                <el-radio-group v-model="formData.determine8">
                    <el-radio label="√"></el-radio>
                    <el-radio label="×"></el-radio>
                    <el-radio label="/"></el-radio>
                </el-radio-group>
            </div>
            <!-- 序号: 8 -->
            <el-descriptions title="序号: 8 项目编号: A2.2.2.9"
                             style="  ">
            </el-descriptions>
            <div style="display:flex;flex-direction: row; ">
                <div style="font-weight:bold">&nbsp;&nbsp;(1)</div>
                <div style="font-weight:bold">&nbsp;&nbsp;检测内容与要求: <text
                        style="font-weight:100">受检设备出入口附近设有紧急停止开关，必要时增设附加紧急停止开关，以使紧急停止开关之间的距离不超过30m(适用于自动扶梯)或者40m(适用于自动人行道)</text>
                </div>
            </div>
            <div  style="display:flex;flex-direction: row; justify-content: space-around;margin-top: 10px ">
                <div style="font-weight:bold">&nbsp;&nbsp;检测项目: <text style="font-weight:100">紧急停止开关之间的距离</text></div>
                <div style="font-weight:bold">&nbsp;&nbsp;单位: <text style="font-weight:100">m</text></div>
                <div style="font-weight:bold">&nbsp;&nbsp;观测数据: <el-input style="font-weight:100;width:200px"
                                                                          v-model="formData.data15" placeholder="请输入">
                </el-input></div>
                <div style="font-weight:bold">&nbsp;&nbsp;测量结果: <el-input style="font-weight:100;width:200px"
                                                                          v-model="formData.result15" placeholder="请输入">
                </el-input></div>
            </div>

            <div style="font-weight:bold;margin-top: 10px">&nbsp;&nbsp;结果判定:
                <el-radio-group v-model="formData.determine9">
                    <el-radio label="√"></el-radio>
                    <el-radio label="×"></el-radio>
                    <el-radio label="/"></el-radio>
                </el-radio-group>
            </div>
            <div style="display:flex;flex-direction: row; margin-top: 10px">
                <div style="font-weight:bold">&nbsp;&nbsp;(2)</div>
                <div style="font-weight:bold">&nbsp;&nbsp;检测内容与要求: <text
                        style="font-weight:100">各紧急停止开关标识清晰，对于位于扶手装置高度1/2以下的紧急停止开关，在扶手装置高度1/2以上的醒目位置还设有直径至少为80mm的红底白字“急停”指示标记，箭头指向该开关</text>
                </div>
            </div>
            <div  style="display:flex;flex-direction: row; justify-content: space-around;margin-top: 10px ">
                <div style="font-weight:bold">&nbsp;&nbsp;检测项目: <text style="font-weight:100">指示标记直径</text>
                </div>
                <div style="font-weight:bold">&nbsp;&nbsp;单位: <text style="font-weight:100">mm</text></div>
                <div style="font-weight:bold">&nbsp;&nbsp;观测数据: <el-input style="font-weight:100;width: 200px"
                                                                          v-model="formData.data16" placeholder="请输入">
                </el-input></div>
                <div style="font-weight:bold">&nbsp;&nbsp;测量结果: <el-input style="font-weight:100;width: 200px"
                                                                          v-model="formData.result16" placeholder="请输入">
                </el-input></div>
            </div>
            <div style="font-weight:bold">&nbsp;&nbsp;结果判定:
                <el-radio-group v-model="formData.determine10">
                    <el-radio label="√"></el-radio>
                    <el-radio label="×"></el-radio>
                    <el-radio label="/"></el-radio>
                </el-radio-group>
            </div>
            <!-- 序号: 9 -->
            <el-descriptions title="序号: 9 项目编号: A2.2.3.1"
                             style="  ">
            </el-descriptions>
            <div style="display:flex;flex-direction: row;  ">
                <div style="font-weight:bold">&nbsp;&nbsp;(1)</div>
                <div style="font-weight:bold">&nbsp;&nbsp;检测内容与要求: <text
                        style="font-weight:100">扶手带完好、表面无龟裂、剥离、严重磨损，扶手带单一开裂处最大裂纹宽度不大于3mm</text>
                </div>
            </div>
            <div  style="display:flex;flex-direction: row; justify-content: space-around;margin-top: 10px ">
                <div style="font-weight:bold">&nbsp;&nbsp;检测项目: <text style="font-weight:100">最大裂纹宽度</text></div>
                <div style="font-weight:bold">&nbsp;&nbsp;单位: <text style="font-weight:100">mm</text></div>
                <div style="font-weight:bold">&nbsp;&nbsp;观测数据: <el-input style="font-weight:100;width:200px"
                                                                          v-model="formData.data17" placeholder="请输入">
                </el-input></div>
                <div style="font-weight:bold">&nbsp;&nbsp;测量结果: <el-input style="font-weight:100;width:200px"
                                                                          v-model="formData.result17" placeholder="请输入">
                </el-input></div>
            </div>
            <div style="font-weight:bold;margin-top: 10px">&nbsp;&nbsp;结果判定:
                <el-radio-group v-model="formData.determine11">
                    <el-radio label="√"></el-radio>
                    <el-radio label="×"></el-radio>
                    <el-radio label="/"></el-radio>
                </el-radio-group>
            </div>
            <div style="display:flex;flex-direction: row; margin-top:10px">
                <div style="font-weight:bold">&nbsp;&nbsp;(2)</div>
                <div style="font-weight:bold">&nbsp;&nbsp;检测内容与要求: <text
                        style="font-weight:100">扶手转向端入口处的最低点与地板之间的垂直距离不小于0.10m，并且不大于0.25m</text>
                </div>
            </div>
            <div  style="display:flex;flex-direction: row; justify-content: space-around;margin-top: 10px ">
                <div style="font-weight:bold">&nbsp;&nbsp;检测项目: <text style="font-weight:100">垂直距离</text>
                </div>
                <div style="font-weight:bold">&nbsp;&nbsp;单位: <text style="font-weight:100">m</text></div>
                <div style="font-weight:bold">&nbsp;&nbsp;观测数据: <el-input style="font-weight:100;width:200px"
                                                                          v-model="formData.data18" placeholder="请输入">
                </el-input></div>
                <div style="font-weight:bold">&nbsp;&nbsp;测量结果: <el-input style="font-weight:100;width:200px"
                                                                          v-model="formData.result18" placeholder="请输入">
                </el-input></div>
            </div>
            <div style="font-weight:bold;margin-top: 10px">&nbsp;&nbsp;结果判定:
                <el-radio-group v-model="formData.determine12">
                    <el-radio label="√"></el-radio>
                    <el-radio label="×"></el-radio>
                    <el-radio label="/"></el-radio>
                </el-radio-group>
            </div>
            <div style="display:flex;flex-direction: row; justify-content: space-around;">
                <div style="font-weight:bold">&nbsp;&nbsp;(3)</div>
                <div style="font-weight:bold">&nbsp;&nbsp;检测内容与要求: <text
                        style="font-weight:100">朝向梯级、踏板或者胶带一侧的部分光滑、平齐；装设方向与运行方向不一致的压条或者镶条凸出高度不大于3mm，其边缘呈圆角或者倒角状；沿运行方向的盖板连接处结构能够防止勾绊</text>
                </div>
            </div>
            <div  style="display:flex;flex-direction: row; justify-content: space-around;margin-top: 10px ">
                <div style="font-weight:bold">&nbsp;&nbsp;检测项目: <text style="font-weight:100">凸出高度</text>
                </div>
                <div style="font-weight:bold">&nbsp;&nbsp;单位: <text style="font-weight:100">mm</text></div>
                <div style="font-weight:bold">&nbsp;&nbsp;观测数据: <el-input style="font-weight:100;width:200px"
                                                                          v-model="formData.data19" placeholder="请输入">
                </el-input></div>
                <div style="font-weight:bold">&nbsp;&nbsp;测量结果: <el-input style="font-weight:100;width:200px"
                                                                          v-model="formData.result19" placeholder="请输入">
                </el-input></div>
            </div>

            <div style="font-weight:bold;margin-top: 10px">&nbsp;&nbsp;结果判定:
            <el-radio-group v-model="formData.determine13">
                <el-radio label="√"></el-radio>
                <el-radio label="×"></el-radio>
                <el-radio label="/"></el-radio>
            </el-radio-group>
        </div>
            <!-- 序号: 10 -->
            <el-descriptions title="序号: 10 项目编号: A2.2.3.3"
                             style="  ">
            </el-descriptions>
            <div style="display:flex;flex-direction: row; ">
                <div style="font-weight:bold">&nbsp;&nbsp;(1)</div>
                <div style="font-weight:bold">&nbsp;&nbsp;检测内容与要求: <text
                        style="font-weight:100">防爬装置在位于地平面上方1000mm±50mm处</text>
                </div>
            </div>
            <div  style="display:flex;flex-direction: row; justify-content: space-around;margin-top: 10px ">
                <div style="font-weight:bold">&nbsp;&nbsp;检测项目: <text style="font-weight:100">防爬装置离地平面距离</text></div>
                <div style="font-weight:bold">&nbsp;&nbsp;单位: <text style="font-weight:100">mm</text></div>
                <div style="font-weight:bold">&nbsp;&nbsp;观测数据: <el-input style="font-weight:100;width:200px"
                                                                          v-model="formData.data20" placeholder="请输入">
                </el-input>
                </div>
                <div style="font-weight:bold">&nbsp;&nbsp;测量结果: <el-input style="font-weight:100;width:200px"
                                                                          v-model="formData.result20" placeholder="请输入">
                </el-input></div>
            </div> 
            <div style="display:flex;flex-direction: row; margin-top:10px">
                <div style="font-weight:bold">&nbsp;&nbsp;(2)</div>
                <div style="font-weight:bold">&nbsp;&nbsp;检测内容与要求: <text
                        style="font-weight:100">防爬装置高度至少与扶手带表面齐平，下部与外盖板相交，平行于外盖板方向上的延伸长度不小于1000mm，并且在此长度范围内无踩脚处</text>
                </div>
            </div>
            <div  style="display:flex;flex-direction: row; justify-content: space-around;margin-top: 10px ">
                <div style="font-weight:bold">&nbsp;&nbsp;检测项目: <text style="font-weight:100">防爬装置延伸长度</text>
                </div>
                <div style="font-weight:bold">&nbsp;&nbsp;单位: <text style="font-weight:100">mm</text></div>
                <div style="font-weight:bold">&nbsp;&nbsp;观测数据: <el-input style="font-weight:100;width:200px"
                                                                          v-model="formData.data21" placeholder="请输入">
                </el-input></div>
                <div style="font-weight:bold">&nbsp;&nbsp;测量结果: <el-input style="font-weight:100;width:200px"
                                                                          v-model="formData.result21" placeholder="请输入">
                </el-input></div>
            </div>
            <div style="font-weight:bold;margin-top: 10px">&nbsp;&nbsp;结果判定:
                <el-radio-group v-model="formData.determine14">
                    <el-radio label="√"></el-radio>
                    <el-radio label="×"></el-radio>
                    <el-radio label="/"></el-radio>
                </el-radio-group>
            </div>
            <!-- 序号: 11 -->
            <el-descriptions title="序号: 11 项目编号: A2.2.3.4"
                             style="  ">
            </el-descriptions>
            <div style="display:flex;flex-direction: row; ">
                <div style="font-weight:bold">&nbsp;&nbsp;(1)</div>
                <div style="font-weight:bold">&nbsp;&nbsp;检测内容与要求: <text
                        style="font-weight:100">对于与墙相邻并且外盖板的宽度大于125mm的受检设备，或者相邻平行布置并且共用外盖板的宽度大于125mm的自动扶梯或者倾斜的自动人行道，检查在上、下端部装设的阻挡装置是否能够防止人员进入外盖板区域，并且延伸到高度距离扶手带下缘25mm～150mm处</text>
                </div>
            </div>
            <div  style="display:flex;flex-direction: row; justify-content: space-around;margin-top: 10px ">
                <div style="font-weight:bold">&nbsp;&nbsp;检测项目: <text style="font-weight:100">外盖板宽度</text></div>
                <div style="font-weight:bold">&nbsp;&nbsp;单位: <text style="font-weight:100">mm</text></div>
                <div style="font-weight:bold">&nbsp;&nbsp;观测数据: <el-input style="font-weight:100;width:200px"
                                                                          v-model="formData.data22" placeholder="请输入">
                </el-input></div>
                <div style="font-weight:bold">&nbsp;&nbsp;测量结果: <el-input style="font-weight:100;width:200px"
                                                                          v-model="formData.result22" placeholder="请输入">
                </el-input></div>
            </div>
            <div  style="display:flex;flex-direction: row; justify-content: space-around;margin-top: 10px ">
                <div style="font-weight:bold">&nbsp;&nbsp;检测项目: <text style="font-weight:100">阻挡装置与扶手带下缘的距离</text>
                </div>
                <div style="font-weight:bold">&nbsp;&nbsp;单位: <text style="font-weight:100">mm</text></div>
                <div style="font-weight:bold">&nbsp;&nbsp;观测数据: <el-input style="font-weight:100;width:200px"
                                                                          v-model="formData.data23" placeholder="请输入">
                </el-input></div>
                <div style="font-weight:bold">&nbsp;&nbsp;测量结果: <el-input style="font-weight:100;width:200px"
                                                                          v-model="formData.result23" placeholder="请输入">
                </el-input></div>
            </div>
            <div style="font-weight:bold;margin-top: 10px">&nbsp;&nbsp;结果判定:
                <el-radio-group v-model="formData.determine15">
                    <el-radio label="√"></el-radio>
                    <el-radio label="×"></el-radio>
                    <el-radio label="/"></el-radio>
                </el-radio-group>
            </div>

            <!-- 序号: 12 -->
            <el-descriptions title="序号: 12 项目编号: A2.2.3.5"
                             style="  ">
            </el-descriptions>
            <div style="display:flex;flex-direction: row;  ">
                <div style="font-weight:bold">&nbsp;&nbsp;(1)</div>
                <div style="font-weight:bold">&nbsp;&nbsp;检测内容与要求: <text
                        style="font-weight:100">自动扶梯或者倾斜的自动人行道和相邻的墙之间装有接近扶手带高度的扶手盖板，并且建筑物(墙)和扶手带中心线之间的距离大于300mm时，或者相邻自动扶梯或者倾斜的自动人行道的扶手带中心线之间的距离大于400mm时，检查在扶手盖板上装设的防滑行装置是否无锐角或者锐边，与扶手带的距离不小于100mm，并且防滑行装置之间的间隔距离不大于1800mm，高度不小于20mm</text>
                </div> 
            </div>
            <div  style="display:flex;flex-direction: row; justify-content: space-around;margin-top: 10px ">
                <div style="font-weight:bold">&nbsp;&nbsp;检测项目: <text
                        style="font-weight:100">建筑物（墙）和扶手带中心线或者相邻设备扶手带中心线之间的距离</text></div>
                <div style="font-weight:bold">&nbsp;&nbsp;单位: <text style="font-weight:100">mm</text></div>
                <div style="font-weight:bold">&nbsp;&nbsp;观测数据: <el-input style="font-weight:100;width:200px"
                                                                          v-model="formData.data24" placeholder="请输入">
                </el-input></div>
                <div style="font-weight:bold">&nbsp;&nbsp;测量结果: <el-input style="font-weight:100;width:200px"
                                                                          v-model="formData.result24" placeholder="请输入">
                </el-input></div>
            </div>
            <div  style="display:flex;flex-direction: row; justify-content: space-around;margin-top: 10px ">
                <div style="font-weight:bold">&nbsp;&nbsp;检测项目: <text style="font-weight:100">防滑行装置与扶手带距离</text>
                </div>
                <div style="font-weight:bold">&nbsp;&nbsp;单位: <text style="font-weight:100">mm</text></div>
                <div style="font-weight:bold">&nbsp;&nbsp;观测数据: <el-input style="font-weight:100;width:200px"
                                                                          v-model="formData.data25" placeholder="请输入">
                </el-input></div>
                <div style="font-weight:bold">&nbsp;&nbsp;测量结果: <el-input style="font-weight:100;width:200px"
                                                                          v-model="formData.result25" placeholder="请输入">
                </el-input></div>
            </div>
            <div  style="display:flex;flex-direction: row; justify-content: space-around;margin-top: 10px ">
                <div style="font-weight:bold">&nbsp;&nbsp;检测项目: <text style="font-weight:100">防滑行装置之间的间隔距离</text>
                </div>
                <div style="font-weight:bold">&nbsp;&nbsp;单位: <text style="font-weight:100">mm</text></div>
                <div style="font-weight:bold">&nbsp;&nbsp;观测数据: <el-input style="font-weight:100;width:200px"
                                                                          v-model="formData.data26" placeholder="请输入">
                </el-input></div>
                <div style="font-weight:bold">&nbsp;&nbsp;测量结果: <el-input style="font-weight:100;width:200px"
                                                                          v-model="formData.result26" placeholder="请输入">
                </el-input></div>
            </div>
            <div  style="display:flex;flex-direction: row; justify-content: space-around;margin-top: 10px ">
                <div style="font-weight:bold">&nbsp;&nbsp;检测项目: <text style="font-weight:100">防滑行装置的高度</text>
                </div>
                <div style="font-weight:bold">&nbsp;&nbsp;单位: <text style="font-weight:100">mm</text></div>
                <div style="font-weight:bold">&nbsp;&nbsp;观测数据: <el-input style="font-weight:100;width:200px"
                                                                          v-model="formData.data27" placeholder="请输入">
                </el-input></div>
                <div style="font-weight:bold">&nbsp;&nbsp;测量结果: <el-input style="font-weight:100;width:200px"
                                                                          v-model="formData.result27" placeholder="请输入">
                </el-input></div>
            </div>
            
            <div style="font-weight:bold;margin-top:10px">&nbsp;&nbsp;结果判定:
                <el-radio-group v-model="formData.determine16">
                    <el-radio label="√"></el-radio>
                    <el-radio label="×"></el-radio>
                    <el-radio label="/"></el-radio>
                </el-radio-group>
            </div>
            <!-- 序号: 13 -->
            <el-descriptions title="序号: 13 项目编号: A2.2.3.6"
                             style="  ">
            </el-descriptions>
            <div style="display:flex;flex-direction: row;  ">
                <div style="font-weight:bold">&nbsp;&nbsp;(1)</div>
                <div style="font-weight:bold">&nbsp;&nbsp;检测内容与要求: <text
                        style="font-weight:100">检查护壁板之间的间隙是否不大于4mm，其边缘是否呈圆角或者倒角状</text></div>


            </div>
            <div  style="display:flex;flex-direction: row; justify-content: space-around;margin-top: 10px ">
                <div style="font-weight:bold">&nbsp;&nbsp;检测项目: <text style="font-weight:100">护壁板间隙</text></div>
                <div style="font-weight:bold">&nbsp;&nbsp;单位: <text style="font-weight:100">mm</text></div>
                <div style="font-weight:bold">&nbsp;&nbsp;观测数据: <el-input style="font-weight:100;width:200px"
                                                                          v-model="formData.data28" placeholder="请输入">
                </el-input></div>
                <div style="font-weight:bold">&nbsp;&nbsp;测量结果: <el-input style="font-weight:100;width:200px"
                                                                          v-model="formData.result28" placeholder="请输入">
                </el-input></div>
            </div>

            <div style="font-weight:bold;margin-top:10px">&nbsp;&nbsp;结果判定:
                <el-radio-group v-model="formData.determine17">
                    <el-radio label="√"></el-radio>
                    <el-radio label="×"></el-radio>
                    <el-radio label="/"></el-radio>
                </el-radio-group>
            </div>
            <!-- 序号: 14 -->
            <el-descriptions title="序号: 14 项目编号: A2.2.3.7"
                             style="  ">
            </el-descriptions>
            <div style="display:flex;flex-direction: row;  ">
                <div style="font-weight:bold">&nbsp;&nbsp;(1)</div>
                <div style="font-weight:bold">&nbsp;&nbsp;检测内容与要求: <text
                        style="font-weight:100">任何一侧的水平间隙不大于4mm，并且两侧对称位置处的间隙总和不大于7mm</text>
                </div>
            </div>
            <div  style="display:flex;flex-direction: row; justify-content: space-around;margin-top: 10px ">
                <div style="font-weight:bold">&nbsp;&nbsp;检测项目: <text style="font-weight:100">单侧水平间隙</text></div>
                <div style="font-weight:bold">&nbsp;&nbsp;单位: <text style="font-weight:100">mm</text></div>
                <div style="font-weight:bold">&nbsp;&nbsp;观测数据: <el-input style="font-weight:100;width:200px"
                                                                          v-model="formData.data29" placeholder="请输入">
                </el-input></div>
                <div style="font-weight:bold">&nbsp;&nbsp;测量结果: <el-input style="font-weight:100;width:200px"
                                                                          v-model="formData.result29" placeholder="请输入">
                </el-input></div>
            </div>
            <div  style="display:flex;flex-direction: row; justify-content: space-around;margin-top: 10px ">
                <div style="font-weight:bold">&nbsp;&nbsp;检测项目: <text style="font-weight:100">两侧间隙总和</text></div>
                <div style="font-weight:bold">&nbsp;&nbsp;单位: <text style="font-weight:100">mm</text></div>
                <div style="font-weight:bold">&nbsp;&nbsp;观测数据: <el-input style="font-weight:100;width:200px"
                                                                          v-model="formData.data30" placeholder="请输入">
                </el-input></div>
                <div style="font-weight:bold">&nbsp;&nbsp;测量结果: <el-input style="font-weight:100;width:200px"
                                                                          v-model="formData.result30" placeholder="请输入">
                </el-input></div>
            </div>
            <div style="font-weight:bold;margin-top:10px">&nbsp;&nbsp;结果判定:
                <el-radio-group v-model="formData.determine18">
                    <el-radio label="√"></el-radio>
                    <el-radio label="×"></el-radio>
                    <el-radio label="/"></el-radio>
                </el-radio-group>
            </div>

            <div style="display:flex;flex-direction: row; margin-top: 10px">
                <div style="font-weight:bold">&nbsp;&nbsp;(2)</div>
                <div style="font-weight:bold">&nbsp;&nbsp;检测内容与要求: <text
                        style="font-weight:100">围裙板设置在踏板之上时，踏板表面与围裙板下端的垂直间隙不大于4mm，踏板侧边与围裙板垂直投影间不产生间隙</text>
                </div>
            </div>
            <div  style="display:flex;flex-direction: row; justify-content: space-around;margin-top: 10px ">
                <div style="font-weight:bold">&nbsp;&nbsp;检测项目: <text style="font-weight:100">踏板表面与围裙板下端的垂直间隙</text>
                </div>
                <div style="font-weight:bold">&nbsp;&nbsp;单位: <text style="font-weight:100">mm</text></div>
                <div style="font-weight:bold">&nbsp;&nbsp;观测数据: <el-input style="font-weight:100;width:200px"
                                                                          v-model="formData.data31" placeholder="请输入">
                </el-input></div>
                <div style="font-weight:bold">&nbsp;&nbsp;测量结果: <el-input style="font-weight:100;width:200px"
                                                                          v-model="formData.result31" placeholder="请输入">
                </el-input></div>
            </div>

            <div style="font-weight:bold;margin-top: 10px">&nbsp;&nbsp;结果判定:
                <el-radio-group v-model="formData.determine19">
                    <el-radio label="√"></el-radio>
                    <el-radio label="×"></el-radio>
                    <el-radio label="/"></el-radio>
                </el-radio-group>
            </div>
            <!-- 序号: 15 -->
            <el-descriptions title="序号: 15 项目编号: A2.2.3.8"
                             style="  ">
            </el-descriptions>
            <div style="display:flex;flex-direction: row;  ">
                <div style="font-weight:bold">&nbsp;&nbsp;(2)</div>
                <div style="font-weight:bold">&nbsp;&nbsp;检测内容与要求: <text
                        style="font-weight:100">围裙板防夹装置端点位于梳齿与踏面相交线前(梯级侧)不小于50mm，但不大于150mm 的位置</text></div>


            </div>
            <div  style="display:flex;flex-direction: row; justify-content: space-around;margin-top: 10px ">
                <div style="font-weight:bold">&nbsp;&nbsp;检测项目: <text style="font-weight:100">防夹装置端点位置</text></div>
                <div style="font-weight:bold">&nbsp;&nbsp;单位: <text style="font-weight:100">mm</text></div>
                <div style="font-weight:bold">&nbsp;&nbsp;观测数据: <el-input style="font-weight:100;width:200px"
                                                                          v-model="formData.data32" placeholder="请输入">
                </el-input></div>
                <div style="font-weight:bold">&nbsp;&nbsp;测量结果: <el-input style="font-weight:100;width:200px"
                                                                          v-model="formData.result32" placeholder="请输入">
                </el-input></div>
            </div>

            <div style="font-weight:bold;margin-top:10px">&nbsp;&nbsp;结果判定:
                <el-radio-group v-model="formData.determine20">
                    <el-radio label="√"></el-radio>
                    <el-radio label="×"></el-radio>
                    <el-radio label="/"></el-radio>
                </el-radio-group>
            </div>
            <!-- 序号: 16 -->
            <el-descriptions title="序号: 16 项目编号: A2.2.4.1"
                             style="  ">
            </el-descriptions>
            <div style="display:flex;flex-direction: row;  ">
                <div style="font-weight:bold">&nbsp;&nbsp;(2)</div>
                <div style="font-weight:bold">&nbsp;&nbsp;检测内容与要求: <text
                        style="font-weight:100">在工作区段内的任何位置，从踏面测得的两个相邻梯级或者踏板之间的间隙不大于6mm；在自动人行道过渡曲线区段，如果踏板的前缘和相邻踏板的后缘啮合，其间隙允许增至8mm</text>
                </div>
            </div>
            <div  style="display:flex;flex-direction: row; justify-content: space-around;margin-top: 10px ">
                <div style="font-weight:bold">&nbsp;&nbsp;检测项目: <text style="font-weight:100">相邻梯级或者踏板间隙</text></div>
                <div style="font-weight:bold">&nbsp;&nbsp;单位: <text style="font-weight:100">mm</text></div>
                <div style="font-weight:bold">&nbsp;&nbsp;观测数据: <el-input style="font-weight:100;width:200px"
                                                                          v-model="formData.data33" placeholder="请输入">
                </el-input></div>
                <div style="font-weight:bold">&nbsp;&nbsp;测量结果: <el-input style="font-weight:100;width:200px"
                                                                          v-model="formData.result33" placeholder="请输入">
                </el-input></div>
            </div>

            <div style="font-weight:bold;margin-top: 10px">&nbsp;&nbsp;结果判定:
                <el-radio-group v-model="formData.determine21">
                    <el-radio label="√"></el-radio>
                    <el-radio label="×"></el-radio>
                    <el-radio label="/"></el-radio>
                </el-radio-group>
            </div>
            <!-- 序号: 17 -->
            <el-descriptions title="序号: 17 项目编号: A2.3.1"
                             style="  ">
            </el-descriptions>
            <div style="display:flex;flex-direction: row;  ">
                <div style="font-weight:bold">&nbsp;&nbsp;(2)</div>
                <div style="font-weight:bold">&nbsp;&nbsp;检测内容与要求: <text
                        style="font-weight:100">对于由使用者的进入而自动启动的受检设备，观察、测量当使用者从预定运行方向进入时，是否经过足够的时间(至少为预期输送时间再加上10s)才能自动停止运行；当使用者从预定运行方向相反的方向进入时，是否仍按照预先确定的方向启动，运行时间不少于10s</text>
                </div>
            </div>
            <div  style="display:flex;flex-direction: row; justify-content: space-around;margin-top: 10px ">
                <div style="font-weight:bold">&nbsp;&nbsp;检测项目: <text style="font-weight:100">自动停止运行时间</text></div>
                <div style="font-weight:bold">&nbsp;&nbsp;单位: <text style="font-weight:100">s</text></div>
                <div style="font-weight:bold">&nbsp;&nbsp;观测数据: <el-input style="font-weight:100;width:200px"
                                                                          v-model="formData.data34" placeholder="请输入">
                </el-input></div>
                <div style="font-weight:bold">&nbsp;&nbsp;测量结果: <el-input style="font-weight:100;width:200px"
                                                                          v-model="formData.result34" placeholder="请输入">
                </el-input></div>
            </div>
            <div  style="display:flex;flex-direction: row; justify-content: space-around;margin-top: 10px ">
                <div style="font-weight:bold">&nbsp;&nbsp;检测项目: <text style="font-weight:100">自动启动运行时间</text>
                </div>
                <div style="font-weight:bold">&nbsp;&nbsp;单位: <text style="font-weight:100">s</text></div>
                <div style="font-weight:bold">&nbsp;&nbsp;观测数据: <el-input style="font-weight:100;width:200px"
                                                                          v-model="formData.data35" placeholder="请输入">
                </el-input></div>
                <div style="font-weight:bold">&nbsp;&nbsp;测量结果: <el-input style="font-weight:100;width:200px"
                                                                          v-model="formData.result35" placeholder="请输入">
                </el-input></div>
            </div>

            <div style="font-weight:bold;margin-top: 10px">&nbsp;&nbsp;结果判定:
                <el-radio-group v-model="formData.determine22">
                    <el-radio label="√"></el-radio>
                    <el-radio label="×"></el-radio>
                    <el-radio label="/"></el-radio>
                </el-radio-group>
            </div>
            <!-- 序号: 18 -->
            <el-descriptions title="序号: 18 项目编号: A2.3.3"
                             style="  ">
            </el-descriptions>
            <div style="display:flex;flex-direction: row;  ">
                <div style="font-weight:bold">&nbsp;&nbsp;(1)&nbsp;&nbsp;检测内容与要求:</div>
                <div style="font-weight:bold">&nbsp;&nbsp;
                    <img src="../../assets/tableA2-2.png" style="width: 60%;height: 100%">
                </div>
            </div>
            <div  style="display:flex;flex-direction: row; justify-content: space-around;margin-top: 10px ">
                <div style="font-weight:bold">&nbsp;&nbsp;检测项目: <text style="font-weight:100">空载上行制停距离</text></div>
                <div style="font-weight:bold">&nbsp;&nbsp;单位: <text style="font-weight:100">m</text></div>
                <div style="font-weight:bold">&nbsp;&nbsp;观测数据: <el-input style="font-weight:100;width:200px"
                                                                          v-model="formData.data36" placeholder="请输入">
                </el-input></div>
                <div style="font-weight:bold">&nbsp;&nbsp;测量结果: <el-input style="font-weight:100;width:200px"
                                                                          v-model="formData.result36" placeholder="请输入">
                </el-input></div>
            </div>
            <div  style="display:flex;flex-direction: row; justify-content: space-around;margin-top: 10px ">
                <div style="font-weight:bold">&nbsp;&nbsp;检测项目: <text style="font-weight:100">空载下行制停距离</text></div>
                <div style="font-weight:bold">&nbsp;&nbsp;单位: <text style="font-weight:100">m</text></div>
                <div style="font-weight:bold">&nbsp;&nbsp;观测数据: <el-input style="font-weight:100;width:200px"
                                                                          v-model="formData.data37" placeholder="请输入">
                </el-input></div>
                <div style="font-weight:bold">&nbsp;&nbsp;测量结果: <el-input style="font-weight:100;width:200px"
                                                                          v-model="formData.result37" placeholder="请输入">
                </el-input></div>
            </div>

            <div style="font-weight:bold;margin-top: 10px">&nbsp;&nbsp;结果判定:
                <el-radio-group v-model="formData.determine23">
                    <el-radio label="√"></el-radio>
                    <el-radio label="×"></el-radio>
                    <el-radio label="/"></el-radio>
                </el-radio-group>
            </div>
            <div style="display:flex;flex-direction: row;margin-top: 10px  ">
                <div style="font-weight:bold">&nbsp;&nbsp;(2)&nbsp;&nbsp;检测内容与要求:</div>
                <div style="font-weight:bold">&nbsp;&nbsp;
                    <img src="../../assets/tableA2-1.png" style="width: 60%;height: 100%">
                </div>
            </div>
            <div  style="display:flex;flex-direction: row; justify-content: space-around;margin-top: 10px ">
                <div style="font-weight:bold">&nbsp;&nbsp;检测项目: <text style="font-weight:100">空载上行制停距离</text>
                </div>
                <div style="font-weight:bold">&nbsp;&nbsp;单位: <text style="font-weight:100">mm</text></div>
                <div style="font-weight:bold">&nbsp;&nbsp;观测数据: <el-input style="font-weight:100;width:200px"
                                                                          v-model="formData.data38" placeholder="请输入">
                </el-input></div>
                <div style="font-weight:bold">&nbsp;&nbsp;测量结果: <el-input style="font-weight:100;width:200px"
                                                                          v-model="formData.result38" placeholder="请输入">
                </el-input></div>
            </div>
            <div  style="display:flex;flex-direction: row; justify-content: space-around;margin-top: 10px ">
                <div style="font-weight:bold">&nbsp;&nbsp;检测项目: <text style="font-weight:100">空载下行制停距离</text>
                </div>
                <div style="font-weight:bold">&nbsp;&nbsp;单位: <text style="font-weight:100">mm</text></div>
                <div style="font-weight:bold">&nbsp;&nbsp;观测数据: <el-input style="font-weight:100;width:200px"
                                                                          v-model="formData.data39" placeholder="请输入">
                </el-input></div>
                <div style="font-weight:bold">&nbsp;&nbsp;测量结果: <el-input style="font-weight:100;width:200px"
                                                                          v-model="formData.result39" placeholder="请输入">
                </el-input></div>
            </div>
            <div style="font-weight:bold;margin-top: 10px">&nbsp;&nbsp;结果判定:
                <el-radio-group v-model="formData.determine24">
                    <el-radio label="√"></el-radio>
                    <el-radio label="×"></el-radio>
                    <el-radio label="/"></el-radio>
                </el-radio-group>
            </div>
        </el-form>
    </div>
    <div style="magin:10px auto;display:flex;flex-direction: row; justify-content:center; ">
        <el-button  type="primary"  @click="back()">
            返回</el-button>
        <el-button  type="primary"  @click="save()">
            保存</el-button>
    </div>
</template>

<script>
    import request from "../../util/request";
    export default {
        // eslint-disable-next-line vue/multi-word-component-names
        name: "observedInfo",
        data() {
            return {
                formData: {},
                saveIs: false,
                ip: localStorage.getItem("ip"), //端口和IP地址
                resu: 0, //用防止重复点击
                recId:this.$route.query.recId,
            }
        },
        created() {
            this.load();
        },
        methods: {
            save() {
                this.saveIs = true;
                let determine = [];
                determine.push(this.formData.determine1, this.formData.determine2, this.formData.determine3, this.formData
                    .determine4, this.formData.determine5, this.formData.determine6, this.formData.determine7, this
                    .formData.determine8, this.formData.determine9, this.formData.determine10, this.formData
                    .determine11, this.formData.determine12, this.formData.determine13, this.formData.determine14, this
                    .formData.determine15, this.formData.determine16, this.formData.determine17, this.formData
                    .determine18, this.formData.determine19, this.formData.determine20, this.formData.determine21, this
                    .formData.determine22, this.formData.determine23, this.formData.determine24);
                let date = [];
                date.push(this.formData.data1, this.formData.data2, this.formData.data3, this.formData
                        .data4, this.formData.data5, this.formData.data6, this.formData.data7, this
                        .formData.data8, this.formData.data9, this.formData.data10, this.formData
                        .data11, this.formData.data12, this.formData.data13, this.formData.data14, this
                        .formData.data15, this.formData.data16, this.formData.data17, this.formData
                        .data18, this.formData.data19, this.formData.data20, this.formData.data21, this
                        .formData.data22, this.formData.data23, this.formData.data24, this.formData.data25, this.formData
                        .data26, this.formData.data27, this.formData.data28, this.formData.data29, this.formData.data30,
                    this.formData.data31, this.formData.data32, this.formData.data33, this.formData.data34, this
                        .formData.data35, this.formData.data36, this.formData.data37, this.formData.data38, this.formData
                        .data39);
                let result = [];
                result.push(this.formData.result1, this.formData.result2, this.formData.result3, this.formData.result4,
                    this.formData.result5, this.formData.result6, this.formData.result7,
                    this.formData.result8, this.formData.result9, this.formData.result10, this.formData
                        .result11, this.formData.result12, this.formData.result13, this.formData.result14, this
                        .formData.result15, this.formData.result16, this.formData.result17, this.formData
                        .result18, this.formData.result19, this.formData.result20, this.formData.result21, this
                        .formData.result22, this.formData.result23, this.formData.result24, this.formData.result25, this
                        .formData
                        .result26, this.formData.result27, this.formData.result28, this.formData.result29, this.formData
                        .result30,
                    this.formData.result31, this.formData.result32, this.formData.result33, this.formData.result34,
                    this.formData.result35, this.formData.result36, this.formData.result37, this.formData.result38,
                    this
                        .formData
                        .result39);
                let map= {
                        "date": date.toString(),
                        "result": result.toString(),
                        "determine": determine.toString(),
                        "observeId": this.formData.observeId,
                        "createBy": sessionStorage.getItem("userName"),
                        "recId": this.recId,
                    };
                 request.post( '/order/observe',map).then(res => {
                        if (res.code === "0") {
                            this.$message({
                                message: "录入成功",
                                type: "success"
                            });
                            this.saveIs = false;
                            this.$router.go(-1);
                        } else {
                            this.$message({
                                message: "录入失败",
                                type: "error"
                            });
                        }
                    })
            },
            load() {
                this.formData = {};
                     request.get( '/order/observeShow',{
                         params:{
                            "recId": this.recId
                            // "recId": 759
                         }
                     }).then(res => {
                         if (res.code === "0") {
                             if (res.data != null && res.data != '无数据') {
                                 this.formData = res.data
                             }
                         } else {
                             this.$message({
                                 message: "查询失败",
                                 type: "error"
                             });
                         }
                     })
            },
            //返回上一页，即向前导航一步。
            back() {
                this.$router.go(-1);
            }
        }
    }
</script>

<style scoped>

</style>